import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Card } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Pagination } from '../../components/ui/Pagination';
import { Skeleton } from '../../components/ui/skeleton';
import { Table, Thead, Tbody, Tr, Th, Td } from '../../components/ui/table';
import { useClients } from '../../hooks/use-clients';

export function ClientsPage() {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useClients({ search: search || undefined });
  const clients = data?.data ?? [];

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-dark-text">Clienți</h1>

      <Card className="p-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
          <Input placeholder="Caută client..." className="pl-9" value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
      </Card>

      <Card>
        <Table>
          <Thead>
            <Tr>
              <Th>Nume client</Th>
              <Th>Cod client</Th>
              <Th>Email</Th>
              <Th>Telefon</Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoading && Array.from({ length: 5 }).map((_, i) => (
              <Tr key={i}><Td colSpan={4}><Skeleton className="h-4 w-full" /></Td></Tr>
            ))}
            {!isLoading && clients.length === 0 && (
              <Tr><Td colSpan={4} className="text-center text-gray-400">Nu s-au găsit clienți</Td></Tr>
            )}
            {clients.map((c) => (
              <Tr key={c.elementId}>
                <Td><Link to={`/admin/clients/${c.elementId}`} className="font-medium text-primary hover:underline">{c.name}</Link></Td>
                <Td className="text-sm text-gray-500">{c.clientCode ?? '—'}</Td>
                <Td className="text-sm text-gray-500">{c.email ?? c.companyEmail ?? '—'}</Td>
                <Td className="text-sm text-gray-500">{c.phone ?? '—'}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Card>
    </div>
  );
}
